import Header48_morph_big from './Header48_morph_big'
export default Header48_morph_big
